import { useLocation } from 'react-router-dom';

const useIsDetailsPage = () => {
  const location = useLocation();

  const detailsPathRegExp = /^\/app\/listings\/(?!import$)[^/]+$/;
  return detailsPathRegExp.test(location.pathname);
};

export { useIsDetailsPage };
